/*
 * @param: obj - 对象
 * @return: Object{
 *	  sortObj[key值按照字母排序的对象]
 *	  sortObjStr[把排序好的对象用字符串连起来]
 * }
 */
export function getObjKeySort(obj) {
  if (Object.prototype.toString.call(obj).slice(8, -1) !== "Object") {
    // throw new Error('参数必须是一个对象');
    return;
  }
  const newkey = Object.keys(obj).sort();
  const objStrArr = [];
  // 先用Object内置类的keys方法获取要排序对象的属性名，再利用Array原型上的sort方法对获取的属性名进行排序，newkey是一个数组
  const newObj = {}; // 创建一个新的对象，用于存放排好序的键值对
  for (let i = 0; i < newkey.length; i++) {
    // 遍历newkey数组
    newObj[newkey[i]] = obj[newkey[i]]; // 向新创建的对象中按照排好的顺序依次增加键值对
    if (typeof obj[newkey[i]] === "object") {
      objStrArr.push(`${newkey[i]}=${JSON.stringify(obj[newkey[i]])}&`);
    } else {
      objStrArr.push(`${newkey[i]}=${obj[newkey[i]]}&`);
    }
  }
  return {
    sortObj: newObj, // 返回排好序的新对象
    sortObjStr: objStrArr.join(""),
  };
}
